import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Footer from '../Footer';

interface Props {
  children: React.JSX.Element | React.JSX.Element[];
}

const WithBackgroundImage: React.FC<Props> = ({ children }) => (
  <div className={clsx('bg-chevron bg-cover bg-fixed', 'min-h-screen w-screen bg-center')}>
    <div className="min-h-[calc(100vh-200px)]">
      <div className="px-2 py-10 text-center lg:p-12 lg:px-12">{children}</div>
    </div>
    <Footer />
  </div>
);

export default observer(WithBackgroundImage);
